var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"DividerLine",style:({height: _vm.props.height +'px'})})}
var staticRenderFns = []

export { render, staticRenderFns }